module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_FIGUACTIVE.18e05831.png";